export default __webpack_public_path__ + "static/media/status_epileptico.b39a8c0f.pdf";